/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_MarInputs */

const en_better_studio_month_mar = /** @type {(inputs: Better_Studio_Month_MarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mar`)
};

/**
* | output |
* | --- |
* | "Mar" |
*
* @param {Better_Studio_Month_MarInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_mar = /** @type {((inputs?: Better_Studio_Month_MarInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_MarInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_mar(inputs)
});